const setCheckoutData = function (state, data) {
    if (!data.shippingContact) {
        data.shippingContact = getEmptyContact()

        // default to subscribe
        data.shippingContact.subscribe = true
    }
    if (!data.billingContact) data.billingContact = getEmptyContact()

    state.data = data
}

const subscribe = function (state) {
    state.data.shippingContact.subscribe = true
}

const setReceiptData = function (state, data) {
    state.receiptData = data

    // if hasOrderBeenPlaced is true then it means that we came here right after the checkout was complete
    if (state.hasOrderBeenPlaced) this.$uiEvents.$emit('orderPlaced', data)
}

const setHasOrderBeenPlaced = function (state, data) {
    state.hasOrderBeenPlaced = data
}

const setIsProcessing = function (state, data) {
    state.isProcessing = data
}

const setBoltToken = function (state, data) {
    state.bolt.token = data
}

const setIsAffirmPayFlow = function (state, bool) {
    state.isAffirmPayFlow = bool
}

const setAutocompleteOff = function (state, bool) {
    state.isAutocompleteOff = bool
}

export default {
    setCheckoutData,
    setReceiptData,
    subscribe,
    setHasOrderBeenPlaced,
    setIsProcessing,
    setIsAffirmPayFlow,
    setBoltToken,
    setAutocompleteOff,
}

// the api doesn't give us these when you haven't saved them, so we can't blindly bind to the api data in our UI, we have to massage a litte
function getEmptyContact() {
    return {
        address1: '',
        address2: '',
        city: '',
        country: 'usa',
        company: '',
        email: '',
        fullName: '',
        phone: '',
        stateId: '',
        zipcode: '',
        subscribe: false,
    }
}
